<div class="flex flex-col gap-1 border border-rounded-sm p-2 rounded bg-slate-100" [ngClass]="{ 'border-slate-300' : !hasValue, 'border-ponder-link' : hasValue }">
    <div class="flex flex-row gap-2 items-center">
        <label class="text-xs sm:text-sm grow" [ngClass]="{ 'text-slate-700' : !hasValue, 'text-ponder-link' : hasValue }">{{ type }}</label>
        @if (hasValue) {
            <button (click)="onClear()">
                <svg-icon [svgIcon]="closeSvgIcon" [small]="true" class="fill-none stroke-ponder hover:stroke-ponder-link"></svg-icon>
            </button>
        }
    </div>
    <select #selectInput (change)="onChange(selectInput.value)" class="p-1 text-xs sm:text-sm bg-slate-50 rounded-sm shadow-sm grow">
        <option [attr.value]="-1"></option>
    @for (item of items ; track item) {
        <option [attr.value]="$index">{{ item }}</option>
    }
    </select>
</div>